































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import reviewFeedback from "@/components/review/reviewFeedback.vue";
import reviewRubric from "@/components/review/reviewRubric.vue";
import {
  fetchUserSessionFeedback,
  fetchDefaultRubric,
  fetchRubricSession,
  submitRubricSession,
  submitReview
} from "@/api.ts";
import { Getter, Action } from "vuex-class";
import {
  SessionFeedback,
  Rubric,
  RubricSession,
  UserSessionResult
} from "@/types";

@Component({
  components: {
    reviewFeedback,
    reviewRubric
  }
})
export default class ReviewFeedbackRubric extends Vue {
  @Prop() private sessionID!: string;
  @Prop() private teamID!: string;
  @Prop() private sessionReviewed!: string;
  @Prop() private isManager!: boolean;
  @Prop() private token: string | undefined;

  @Getter private newReviewCommentVisible!: boolean;
  @Getter private JWT!: string;
  @Getter private sessionFeedback!: SessionFeedback[];
  @Getter private rubricData!: Rubric;
  @Getter private UID!: string;

  @Action private setRubricData!: any;
  @Action private setRubricSessionAnswers!: any;
  @Action private setRubricSessionAnswersByUser!: any;
  @Action private setRubricSessionAverageAnswers!: any;
  @Action private setRubricError!: any;
  @Action private setNewReviewCommentVisible!: any;
  @Action private setReviewCommentSelectedIndex!: any;
  @Action private setTranscriptStartIndex!: any;
  @Action private setTranscriptEndIndex!: any;
  @Action private setReviewFeedbackComments!: any;

  private isCommentsFetched: boolean = false;
  private isRubricFetched: boolean = false;
  private showFeedback: boolean = false;
  private isSessionFeedbackApiFailed: boolean = false;
  private isApiSubmitSession: boolean = false;
  private isSessionReviewed: boolean = true;
  private isRubricAnswered: boolean = false;

  private userScore = 0;
  private scoreMap = new Map();

  private created() {
    this.onSessionReviewed();
    this.fetchComments();
    this.fetchRubricSession();
  }
  private fetchRubricSession() {
    if (this.sessionID) {
      fetchRubricSession(
        this.JWT,
        this.sessionID,
        (rubric: RubricSession[]) => {
          if (rubric && rubric.length) {
            this.isRubricFetched = true;
            this.setRubricData(rubric[0].rubric);
            this.setRubricSessionAnswers(rubric[0].sessionAnswers || []);
            this.setRubricSessionAnswersByUser(rubric[0].answersByUser || []);
            this.setRubricSessionAverageAnswers(rubric[0].averageAnswers || []);
            const answersByUser = rubric[0].answersByUser || [];
            if(this.UID && answersByUser.findIndex(user => user.uid === this.UID)>-1) {
              this.isSessionReviewed = true;
            }
          }
        },
        (error: string) => {
          this.fetchDefaultRubric();
        }
      );
    }
  }

  private fetchComments() {
    if (this.sessionID) {
      fetchUserSessionFeedback(
          this.token === undefined ? this.JWT : this.token,
        this.sessionID,
        (userSessionResult: UserSessionResult) => {
          this.isCommentsFetched = true;
          this.isSessionFeedbackApiFailed = false;
          this.setReviewCommentSelectedIndex(-1);
          this.setNewReviewCommentVisible(false);
          this.setTranscriptStartIndex(-1);
          this.setTranscriptEndIndex(-1);
          this.setReviewFeedbackComments(userSessionResult.Feedback);
        },
        (error: string) => {
          this.isCommentsFetched = true;
          this.isSessionFeedbackApiFailed = true;
        }
      );
    }
  }

  private fetchDefaultRubric() {
    if (this.teamID) {

      fetchDefaultRubric(
        this.JWT,
        this.teamID,
        (rubric: Rubric) => {
          this.isRubricFetched = true;
          this.setRubricData(rubric);
        },
        (error: string) => {
          this.isRubricFetched = true;
          this.setRubricData(null);
        }
      );
    } else {

        this.isRubricFetched = true;
        this.setRubricData(null);
    }
  }

  private toggleTabs(show: boolean) {
    this.showFeedback = show;
  }

  @Watch("newReviewCommentVisible")
  private onNewCommentVisible() {
    if (!this.showFeedback && this.newReviewCommentVisible) {
      this.toggleTabs(true);
    }
  }
  
  private onSessionReviewed() {
    if(this.sessionReviewed && this.sessionReviewed === "true") {
      this.isSessionReviewed = true;
    } else {
      this.isSessionReviewed = false;
    }
  }

  private submitReview() {
    if (!this.isSessionReviewed) {
      if (this.rubricData) {
        this.submitRubric();
      } else {
        this.submitReviewApi();
      }
    }
  }

  private submitRubric() {
      let rubric = this.rubricData;
      let sessionAnswers: any | null = this.rubricToAnswers(rubric);
      if (sessionAnswers) {
        console.log("sessionAnswers:" + sessionAnswers);
        this.isApiSubmitSession = true;
        submitRubricSession(
          this.JWT,
          this.sessionID,
          this.rubricData.rubricSlug,
          this.rubricData.version,
          sessionAnswers,
          (response: string) => {
            this.submitReviewApi();
            this.setRubricSessionAnswers(sessionAnswers.sessionAnswers);
          },
          (error: string) => {
            this.submitFailed();     
          }
        );
      }
  }

  private submitReviewApi() {
    this.isApiSubmitSession = true;
    submitReview(
      this.JWT,
      this.teamID,
      this.sessionID,
      (response: any) => {
        this.isApiSubmitSession = false;
        this.isSessionReviewed = true;
      },
      (error: string) => {
        this.submitFailed();
      }
    );
  }

  private submitFailed() {
    this.isApiSubmitSession = false;
    this.isSessionReviewed = false;
  }

  get submitDisabled() {
    if (this.isSessionReviewed) return true;

    if (this.rubricData) {
      return !this.isRubricAnswered;
    } else {
      return !this.sessionFeedback || this.sessionFeedback.length == 0;
    }
  }

  private onRubricRatingSelected(rating: number, index: number) {
    
    this.scoreMap.set(index, rating);
    let values = Array.from(this.scoreMap.values());
    this.userScore = values.reduce(function(a, b) {
      return a + b;
    });
    
    if (this.scoreMap.size === this.rubricData.questions.length) {
      this.isRubricAnswered = true;
    } else {
      this.isRubricAnswered = false;
    }
  }

  private rubricToAnswers(rubric: Rubric | null): any {
    let sessionAnswers = {
      sessionAnswers: [] as any[]
    };

    for (let i = 0; i < rubric!.questions.length; ++i) {
      let question = rubric!.questions[i];
      let answer = 0;

      sessionAnswers.sessionAnswers.push({
        question: { displayOrder: question.displayOrder as number },
        starsRating: this.scoreMap.get(question.displayOrder) * 2
      });
    }
    return sessionAnswers;
  }
}
